/**
 * Which cast route the TV page's cast button drives, decided from pure data:
 *
 * - `google` — native Google Cast. The Cast Web Sender framework is loaded
 *   and `CAST_APP_ID` names the registered receiver (`/receiver`), so the
 *   cast device runs our own receiver app. This is the only route Chrome on
 *   Android will take at all.
 * - `presentation` — the Presentation API path (`useCast`): Chrome hands the
 *   TV URL to its default receiver. Desktop only, secure context only, and
 *   its own dead-path blocking lives in `useCast`.
 *
 * Anything short of the full google setup falls back to presentation — the
 * button keeps working everywhere it did before.
 */
export type CastStrategy = 'google' | 'presentation';

export interface CastStrategyInput {
  /** `CAST_APP_ID` from `/api/config`, or null when the server has none. */
  appId: string | null;
  /** The sender framework finished loading (`window.cast.framework`). */
  senderSdk: boolean;
  /** Both cast flavors are secure-context-only. */
  secure: boolean;
}

export function castStrategy(input: CastStrategyInput): CastStrategy {
  const configured = typeof input.appId === 'string' && input.appId.trim().length > 0;
  if (configured && input.secure && input.senderSdk) return 'google';
  return 'presentation';
}
